import { render } from "./ManageTechniciansGroupsModal.vue?vue&type=template&id=1f6cf044"
import script from "./ManageTechniciansGroupsModal.vue?vue&type=script&lang=js"
export * from "./ManageTechniciansGroupsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__